import { AuditTimeTypeEnum } from 'src/app/shared/interfaces/AuditTimeTypeEnum';
import { ReportTimeTypeEnum } from 'src/app/shared/interfaces/ReportTimeTypeEnum';

export const REPORT_TYPES_LIST = [
  {
    id: 0,
    name: 'Periodic Inventory Report',
    description: 'A snapshot of the current inventory levels.',
  },
  {
    id: 1,
    name: 'Biennial Inventory Report',
    description: 'Same as periodic, but should be run once every two years.',
  },
];

export const REPORT_TIME_LIST = [
  {
    id: ReportTimeTypeEnum.StartOfDay,
    name: 'Beginning of Business (BOB)',
    description: 'Before any prescriptions have been filled.',
  },
  {
    id: ReportTimeTypeEnum.EndOfDay,
    name: 'Close of Business (COB)',
    description: 'After all prescriptions have been filled.',
  },
];

export const AUDIT_TIME_LIST = [
  {
    id: AuditTimeTypeEnum.BeginningOfDay,
    name: 'BOB',
    description: 'Beginning of Business',
  },
  {
    id: AuditTimeTypeEnum.EndOfDay,
    name: 'COB',
    description: 'Close of Business',
  }
];